<!-- 卡密管理 -->
<template>
    <div class="cardpwdManage-container">
        <div class="product-info">
            <el-card class="mb16">
                <div>
                    <div class="merchant-info">
                    <div class="info-row">
                            <div class="info-item">
                                <span class="label">商户号</span>
                                <span class="value">{{productData.profileInfo.api_key}}</span>
                                <i v-if="productData.profileInfo.api_key" class="el-icon-copy-document copy-icon" @click="copy(productData.profileInfo.api_key)"></i>
                            </div>
                    </div>
                    <div class="info-row">
                            <div class="info-item">
                                <span class="label">签名密钥</span>
                                <span class="value encrypted-key">{{productData.profileInfo.api_secret}}</span>
                                <el-button type="text" class="fs12" @click="showsecret('api_secret')"><i class="el-icon-view"></i> 查看 </el-button>
                                <i class="el-icon-copy-document copy-icon" @click="copy(productData.profileInfo.api_secret)"></i>
                            </div>
                    </div>
                    <div class="info-row">
                            <div class="info-item">
                                <span class="label">AES密钥</span>
                                <span class="value encrypted-key">{{productData.profileInfo.aes_secret}}</span>
                                <el-button type="text" class="fs12" size="mini" @click="showsecret('aes_secret')"><i class="el-icon-view"></i> 查看 </el-button>
                                <i class="el-icon-copy-document copy-icon" @click="copy(productData.profileInfo.aes_secret)"></i>
                            </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <span class="label">IP白名单</span>
                            <span class="value ip-list">{{productData.profileInfo.api_ip_whitelist}}</span>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <span class="label">闲鱼接单</span>
                            <el-switch :disabled="productData.loading" v-model="productData.xianyu_enabled" :active-value="1" :inactive-value="0" @change="setXianyuEnabled"></el-switch>
                        </div>
                    </div>
                    <div class="info-row">
                            <div class="info-item">
                                <span class="label">商户余额</span>
                                <span class="value balance-amount">¥{{ productData.profileInfo.money }}</span>
                                <el-button type="primary" class="fs12" size="mini" @click="showBalanceDetail">余额详情 </el-button>
                            </div>
                    </div>
                    </div>
                    
                    <div class="action-buttons">
                        <el-button type="warning" size="small" @click="setIPlist">设置IP白名单</el-button>
                    </div>
                    
                </div>
            </el-card>
        </div>
        <el-card>
            <div class="cardpwdManage-content">
                <div class="cardpwdManage-title">产品费率：</div>
                <div class="cardpwdManage-table-div">
                    <el-table class="table-class" border :data="table.tableData" style="width: 100%;"  :max-height="table.height" header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                        
                        <el-table-column prop="product_name" label="产品名称" >
                            <template slot-scope="scope">
                                <div class="cdanger"> {{ scope.row.product_name }}</div>
                            </template>
                        </el-table-column>               
                        <el-table-column prop="product_code" label="产品编码"></el-table-column>    
                        <el-table-column prop="discount" label="费率" width="180px">
                            <template slot-scope="scope">
                                <div class="cdanger"> {{ scope.row.discount }}</div>
                            </template>
                        </el-table-column>       
                        <el-table-column label="商品链接">
                            <template slot-scope="scope">
                                <el-link size="mini" type="primary">{{ scope.row.goods_url }}</el-link>    
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="180px">
                            <template slot-scope="scope">
                                <el-tag size="mini" :type=" scope.row.enabled== 1 ? 'success':'danger'" >{{ scope.row.enabled== 1 ?'已开启':'已禁用' }}</el-tag>  
                            </template>
                        </el-table-column>
                        <el-table-column label="闲鱼接单状态" width="180px">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.xianyu_enabled" :active-value="1" :inactive-value="0" :disabled="productData.xianyu_enabled != 1 || productData.loading" @change="setProductXianyuEnabled(scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="闲鱼配置" width="180px">
                            <template slot-scope="scope">
                                <el-button type="text"  @click="setXianYuConfig(scope.row)">配置({{scope.row.xianyu_link_count}})</el-button>
                            </template>
                        </el-table-column>
                        

                    </el-table>
                    
                </div>
            </div>
        </el-card>
        <div class="dialog-div">
            <SetWhiteIP v-if="dialog.setIPlist.visible" title="设置IP白名单" :visible="dialog.setIPlist.visible" :ip_list="productData.profileInfo.api_ip_whitelist" :loading="dialog.loading" @close="closeSetIPlist" @sure="sureSetIPlist"></SetWhiteIP>
            <ShowSecret v-if="dialog.secretDialog.visible" title="查看签名密钥" :visible="dialog.secretDialog.visible" :loading="dialog.loading" @close="closeSecret" @sure="sureSecret"></ShowSecret>
            <BalanceDetail v-if="dialog.balanceDetail.visible" @closeBalanceDetail = "closeBalanceDetail" :dialogVisible="dialog.balanceDetail.visible"></BalanceDetail>
            <xianYuLink v-if="dialog.xianYu.visible" :dialogVisible = "dialog.xianYu.visible" :formData = "dialog.xianYu.form" @close="closeXianYuLink" @getData = "productConfigs"></xianYuLink>
        </div>
        
    </div>

   
</template>
<script>
	import {
		Message
	} from 'element-ui'
    import ShowSecret from '@/components/product/showSecret.vue'    
    import BalanceDetail from '@/components/product/balanceDetail.vue'
    import SetWhiteIP from '@/components/product/setWhiteIP.vue' 
    import xianYuLink from "@/components/product/xianYuLink.vue"

    export default {
        name: 'cardpwdManage',
        data() {
            var checkPrice = function (rule, val, callback) {
                    if (val) {                   
                        var reg = /^\d+(\.{0,1}\d{1,4}){0,1}$/;
                        if (!reg.test(val)) {
                            return callback(new Error("格式错误,至多四位小数"));
                        } 
                    }
                    return callback();
                };
            //卡包名称验证
            const validateBagName = function(rule, val, callback) {
                if(val){
                    if(val.length < 2 || val.length > 10){
                        return callback(new Error("名称长度不得少于 2 个字符，最多 10 个字符"));
                    }
                    if (/^\d+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else {
                        callback();
                    }
                }
            };
            //商品链接验证功能
            const validateProductUrl = function(rule, val, callback) {
                if(val){
                    if(val.length > 200){
                     callback(new Error('链接长度最多 200 个字符'));
                    }else{
                        callback()
                    }
                }
               
            }
            //折扣比例验证功能
            const validateDiscount = function(rule, val, callback) {
                if(val){
                    if (!/^\d{0,9}$/.test(val)) {
                        return callback(new Error('仅支持整数输入'));
                    }else{
                        callback()
                    }
                }
               
            }
			return {
                traderId:'',//客户id 
				query:{
                    loading:false,
                    id:'',
                    nickname:'',
                    customerId:'',
                    page:1,
                    pageSizesArr:[10,50,200,500],
                    total:0,
                    pageSize: 10,
                    timeSort:'',
                },
                table:{
                    tableData:[],
                    height:'200px',
                  
                },
                dialog:{
                    secretDialog:{
                        visible:false,
                    },
                    balanceDetail:{
                        visible:false,
                    },
                    setIPlist:{
                        visible:false,
                    },
                    //新增 编辑弹窗
                    loading:false,
                    xianYu:{
                        visible:false,
                        form:{}
                    },
                }, 
                
                productData:{
                    show:false,
                    showName:'',
                    profileInfo:{},
                    xianyu_enabled:0,//闲鱼全局开关 0-关闭，1-开启
                    timeout:null,
                    time:10,
                    loading:false,
                }
               
            };
        },
        components: {
            ShowSecret,BalanceDetail,SetWhiteIP,xianYuLink
        },
        created() {
           this.getData()
           this.profileInfo()
           this.getXianyuEnabled()
        },
       
        methods: {
            // 计算表格高度
            getTableHeight(){
                this.$nextTick(() => {
                    let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                    let productInfo = document.getElementsByClassName('product-info')[0].offsetHeight;
                    let cardpwdManageTitle = document.getElementsByClassName('cardpwdManage-title')[0].offsetHeight;
                    
                    let documentHeight = document.documentElement.clientHeight
                    this.table.height = documentHeight - topNav - productInfo - cardpwdManageTitle - 40 - 40 - 16 - 16 - 4 +'px'
                })
            },
            profileInfo(){
                this.$api.profileInfo({}).then(res=>{
                    if(res.status == 1){
                        this.productData.profileInfo = res.data
                    }
                })
            },
            //关闭查看密码弹窗
            closeSecret(){
                this.dialog.secretDialog.visible = false
            },
            //查看密码按钮
            showsecret(name){
                this.dialog.secretDialog.visible = true
                this.productData.showName = name
            },
            //确认查看密码
            sureSecret(form){
                this.dialog.loading = true
                this.$api.getSecrets({password:form.password}).then(res=>{
                    this.dialog.loading = false
                    console.log(res)
                    if(res.status == 1){
                        this.closeSecret()
                        this.dialog.secretDialog.show = true
                        this.$message.success("密钥已显示，10秒后自动隐藏");
                        let api_secret = this.productData.profileInfo.api_secret
                        let aes_secret = this.productData.profileInfo.aes_secret
                        this.productData.profileInfo.api_secret = res.data.api_secret;
                        this.productData.profileInfo.aes_secret = res.data.aes_secret;
                        clearInterval(this.productData.timeout)
                        let time = this.productData.time                        
                        this.productData.timeout = setInterval(()=>{
                            if(time ==0 || time < 0){                    
                                this.dialog.secretDialog.show = false            
                                this.productData.profileInfo.api_secret = api_secret;
                                this.productData.profileInfo.aes_secret = aes_secret;
                                clearInterval(this.productData.timeout)
                                return
                            }
                            time = time -1;                            
                        },1000)

                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(err=>{
                    this.dialog.loading = false
                })
            },
            //复制
            copy(textCopy){
                if(!textCopy){
                    this.$message.error('没有可复制的内容')
                    return
                }
                if(!this.dialog.secretDialog.show){
                    this.$message.error('请先查看密钥')
                    return
                }
                const contentToCopy = textCopy
				// 创建一个临时的 textAREA 元素
				const textarea = document.createElement('textarea')
				textarea.value = contentToCopy
				document.body.appendChild(textarea)
				textarea.select()
				document.execCommand('copy')
				document.body.removeChild(textarea)
				this.$message({
					type: 'success',
					message: '已复制到剪切板'
				})
            },
            //查看余额详情
            showBalanceDetail(){
                this.dialog.balanceDetail.visible = true
            },
            //关闭余额详情弹窗
            closeBalanceDetail(){
                this.dialog.balanceDetail.visible = false 
            },
            //关闭 设置IP白名单弹窗
            closeSetIPlist(){                
                this.dialog.setIPlist.visible = false 
            },
            //打开设置IP白名单弹窗
            setIPlist(){
                this.dialog.setIPlist.visible = true 
            },
            // 确认设置IP白名单
            sureSetIPlist(form){
                let data = {
                    ip_list:form.ip_list
                }
                this.dialog.loading = true
                this.$api.setIpWhitelist(data).then(res=>{ 
                    this.dialog.loading = false
                    if(res.status == 1){
                        this.$message.success(res.msg)
                        this.profileInfo()
                        this.closeSetIPlist()
                    }else{
                        this.$message.error(res.msg)

                    }
                }).catch(err=>{
                    this.dialog.loading = false
                })
            },
            //查询按钮
            getData(){
                this.productConfigs()
            },
            //查询列表
            productConfigs(){                
                this.getTableHeight()
                let data = { }
                this.query.loading = true;
                this.$api.productConfigs(data).then(res=>{
                    this.query.loading = false;
                    if(res.status == 1){
                        this.table.tableData = res.data
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
            //获取闲鱼全局开关
            getXianyuEnabled(){
                this.$api.getXianyuEnabled({}).then(res=>{
                    if(res.status == 1){
                        this.productData.xianyu_enabled = res.data.xianyu_enabled
                    }
                })
            },
            // 打开闲鱼配置弹窗
            setXianYuConfig(item){
                this.dialog.xianYu.visible = true;
                this.dialog.xianYu.form = item
            },
            //关闭闲鱼链接配置弹窗
            closeXianYuLink(){
                this.dialog.xianYu.visible = false;
            },
            //设置闲鱼接单全局开关
            setXianyuEnabled(value){
                let oldenabled = value == 1?0:1
                let xianyu_enabled = value;
                this.productData.xianyu_enabled = oldenabled
                this.productData.loading = true
                this.$api.setXianyuEnabled({xianyu_enabled:xianyu_enabled}).then(res=>{
                    this.productData.loading = false
                    if(res.status == 1){
                        this.getXianyuEnabled();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(e=>{
                    this.productData.loading = false
                })
            },
            //设置产品级别的闲鱼接单开关
            setProductXianyuEnabled(row){
                let oldenabled = row.xianyu_enabled == 0 ? 1 : 0
                let newenabled = row.xianyu_enabled
                row.xianyu_enabled = oldenabled
                let data ={
                    product_code: row.product_code,
                    denomination_value:row.face_value,
                    xianyu_enabled: newenabled,
                }
                this.productData.loading = true
                this.$api.setProductXianyuEnabled(data).then(res=>{ 
                    this.productData.loading = false
                    if(res.status == 1){ 
                        this.getData()
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.productData.loading = false
                })
            }
            
       
        },
        watch: {
           
        }
    }
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
//内层弹窗input框样式
    .dialog-div-input{
        width: 200px;
    }
    .cardpwdManage-container{
        .merchant-info{
            margin-bottom: 20px;
            .info-row {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                .info-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    .label {
                        font-weight: 500;
                        color: #303133;
                        min-width: 80px;
                    }
                    .value {
                        color: #606266;
                        font-weight: 600;
                        margin-right: 8px;
                        &.encrypted-key {
                            font-family: monospace;
                            letter-spacing: 1px;
                            color: #606266;
                            background-color: #fafafa;
                            padding: 4px 8px;
                            border-radius: 4px;
                            font-size: 14px;
                        }
                        &.ip-list {
                            color: #e6a23c;
                            font-weight: 500;
                        }
                        &.balance-amount {
                            font-weight: 700;
                            color: #409eff;
                            font-size: 16px;
                            margin-right: 12px;
                        }
                    }
                    .copy-icon {
                        margin-left: 8px;
                        cursor: pointer;
                        color: #409eff;
                        font-size: 16px;
                        transition: color .3s;
                        &:hover {
                            color: #79bbff;
                        }
                    }
                }
            }
        }
        .action-buttons{
            display: flex;
            gap: 12px;
        }
        .cardpwdManage-content{
            .cardpwdManage-title{
                margin: 0;
                font-size: 16px;
                font-weight: 500;
                color: #303133;
                margin-bottom: 16px;
            }
        }
        
    }
    .dialog-div {
        // .new-dialog-class{
        .dialog-box{
            max-height:70vh !important;
            overflow-y:auto;
        }
        
        .dialog-block-box{
            .dialog-block-box-title{
                font-weight:600;
                font-size:16px;
                margin-bottom: 20px;
            }
            .form-error-div{
                padding-left:100px;
            }
            .dialog-radio-group{
                width:280px;
                .dialog-radio{
                    margin-top: 7px;
                    margin-bottom:13px;
                }
            }
        } 
        // }        
        .card-list-dialog-class {
            .dialog-box{
                .dialog-info-div{
                    padding-right: 30px;
                    display: flex;
                    justify-content: space-between;
                }
                .dialog-query-box{ 
                    padding-right: 30px;
                    margin-top:30px;
                    display: flex;
                    justify-content: space-between;
                    .dialog-query-btn-box{
                        .query-btn{
                            width: 80px;
                            height: 30px;
                        }
                    }
                }
                .dialog-table-box{
                    margin-top:35px;
                    .dialog-card-list-page{
                        margin-top: 30px;
                        justify-content: flex-end;
                    }
                }
            }
        }
    }
</style>